// @core/api/endpoints/bootstrap/save_vault_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SaveVaultConfigRequest,
  SaveVaultConfigResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Save vault configuration
 * Saves the secret service initialization configuration: number of Shamir shares, unseal threshold, and optional auto-unseal provider. Does NOT initialize the vault — that happens during execution.
 * @public This endpoint does not require authentication
 */
export async function SaveVaultConfig(
  data: SaveVaultConfigRequest,
  options?: RequestOptions
): Promise<SaveVaultConfigResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/steps/vault`;
  const requestOptions = { ...options, skipAuth: true };
  return client.put<SaveVaultConfigResponse>(requestPath, data, requestOptions);
}
